import {type PlantHierarchyNode, PlantHierarchyType} from '@hproduce/suite-core'

export interface LocationOption {
  id: string
  name: string
}

export function collectHierarchyNodes(
  plants: PlantHierarchyNode[],
  allowedTypes: PlantHierarchyType[]
): LocationOption[] {
  const result: LocationOption[] = []

  for (const rootNode of plants) {
    collectFromNode(rootNode, allowedTypes, result)
  }

  return result
}

function collectFromNode(
  node: PlantHierarchyNode,
  allowedTypes: PlantHierarchyType[],
  result: LocationOption[]
): void {
  if (allowedTypes.includes(node.type)) {
    result.push({
      id: node.hierarchyId,
      name: node.name
    })
  }

  if (node.children) {
    for (const child of node.children) {
      collectFromNode(child, allowedTypes, result)
    }
  }
}
